export default [
  {
    path: '/BA-alert/',
    component: () => import('@/components/Layer.vue'),
    children: [
      // Root to TAB 1
      {
        path: '',
        redirect: { name: 'baEvent' }
      },
      // TAB 1
      {
        path: 'event',
        name: 'baEvent',
        component: () => import('@/views/BA-alert/BA-alertView.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      // TAB 1 - 回報 - 無參數
      {
        path: 'event/report/',
        redirect: { name: 'baEvent' }
      },
      // TAB 1 - 回報 - 有參數
      {
        path: 'event/report/:id',
        name: 'reportEventById',
        component: () => import('@/views/BA-alert/BA-alertView.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      // TAB 1 - 事件詳情 - 無參數
      {
        path: 'event/detail/',
        redirect: { name: 'baEvent' }
      },
      // TAB 1 - 事件詳情 - 有參數
      {
        path: 'event/detail/:id',
        name: 'eventDetailById',
        component: () => import('@/views/BA-alert/BA-alertView.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      // TAB 1 - 回報 - 有參數
      {
        path: 'privateEvent/report/:id',
        name: 'reportPrivateEventById',
        component: () => import('@/views/BA-alert/BA-alertView.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      // TAB 1 - 事件詳情 - 有參數
      {
        path: 'privateEvent/detail/:id',
        name: 'privateEventDetailById',
        component: () => import('@/views/BA-alert/BA-alertView.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      // TAB 2
      {
        path: 'management',
        name: 'baManagement',
        component: () => import('@/views/BA-alert/BA-alertView.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      // TAB 3
      {
        path: 'log',
        name: 'baLog',
        component: () => import('@/views/BA-alert/BA-alertView.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      // 圖表頁
      {
        path: 'analysis',
        name: 'analysis',
        component: () => import('@/views/BA-alert/AnalysisView.vue'),
        meta: {
          prev: 'baEvent'
        }
      }
    ]
  }
]
